import React from "react";
import { routes } from "utilities/routing/generatedRoutes";
import ConfirmCopyModal from "components/modals/ConfirmCopyModal";

interface Props {
  mainArea: server.dto.MainAreas
  status: server.dto.Status
  isOpen: boolean
  onClose: () => void
}

const ConfirmCopyStatusModal = (props: Props) => {
  const apiCall = async () => {
    const response = await window.CoreApi.Status.Copy(props.status.statusId);
    return response.data;
  };

  return <ConfirmCopyModal
    isOpen={props.isOpen}
    apiCall={apiCall}
    onClose={props.onClose}
    onSuccess={(itemId) => window.location.href = routes.status_Detail(itemId).absolute}
  />;
};

export default ConfirmCopyStatusModal;